import { DebounceInput } from '@components/form/input/debounce-input';
import { RiSearchLine } from 'react-icons/ri';
import { SearchWorkspaceProps } from '../sidebar.types';
import { capitalizeFirst } from '@shared/utils/capitalize';
import { useTranslation } from 'react-i18next';

export function SearchWorkspace({ filter, setFilter }: SearchWorkspaceProps) {
  const { t } = useTranslation();
  return (
    <div className="pt-1 border-b border-gray-400">
      <DebounceInput
        autoFocus
        variant="borderless"
        allowClear
        size="large"
        prefix={<RiSearchLine className="mr-1 size-3.5" />}
        placeholder={capitalizeFirst(t('find_workspace')) + '..'}
        className="font-medium text-sm"
        defaultValue={filter.query}
        setDebouncedValue={(v) => setFilter((prev) => ({ ...prev, query: v }))}
      />
    </div>
  );
}
